export const PHASE_EXECUTION_TIME_GRID_TEMPLATE =
  "minmax(var(--size-120), var(--size-360)) minmax(var(--size-200), 1fr)";
